import { Component } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatRadioGroup } from '@angular/material/radio';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-requirement-filter-dialog',
  standalone: true,
  templateUrl: './requirement-filter-dialog.component.html',
  imports: [
    MatRadioButton,
    MatRadioGroup,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class RequirementFilterDialogComponent {
  situacoes = ['Aguardando', 'Em análise', 'Finalizado', 'Cancelado'];

  requirementFilterForm = new FormGroup({
    situacaoRequerimento: new FormControl(''),
    tipoRequerimento: new FormControl(''),
    // Outros campos de filtros...
  });

  constructor(
    private dialogRef: MatDialogRef<RequirementFilterDialogComponent>
  ) {}

  applyFilters(): void {
    this.dialogRef.close(this.requirementFilterForm.value);
  }

  clearFilters(): void {
    this.requirementFilterForm.reset();
  }
}
